import React from 'react';
import styles from '../styles.scss';

export interface BadgeProps {
  color: string;
}

export interface ChartLabelProps {
  responses?: number;
  total?: number;
  isPrivateRsvp?: boolean;
  allResponded?: boolean;
}
export const Badge: React.FC<BadgeProps> = ({ color }) => (
  <div className={styles.badge} style={{ backgroundColor: color }} />
);

export const ChartLabel: React.FC<ChartLabelProps> = ({
  responses = 0,
  total = 0,
  isPrivateRsvp = false,
  allResponded = false,
}) => {
  let responseTense = 'responded';
  if (!isPrivateRsvp && responses > 1) {
    responseTense = 'responses';
  }
  return (
    <div className={styles.chartLabel}>
      {allResponded ? (
        <>
          <span className={styles.allResponded} />
          <span>Everyone</span>
          <span>responded!</span>
        </>
      ) : (
        <>
          {responses} {isPrivateRsvp ? <span>of {total}</span> : null}
          <span>{responseTense}</span>
        </>
      )}
    </div>
  );
};
